/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { ExternalKey } from './externalKey';
import { ExternalKeys } from './externalKeys';
import { FactorDetailsViewBarcodes } from './factorDetailsViewBarcodes';
import { FactorDetailsViewContainer } from './factorDetailsViewContainer';
import { FactorDetailsViewFactorNotes } from './factorDetailsViewFactorNotes';
import { FactorDetailsViewStock } from './factorDetailsViewStock';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { UpdateDateTime } from './updateDateTime';

export interface FactorDetailsView { 
    /**
     * The unique identifier of this record.
     */
    factorId?: number;
    /**
     * A reference to the primary key in the Stock Table
     */
    stockId?: number;
    divider?: number;
    alhStockCode?: string;
    /**
     * A reference to the primary key in the Containers Table
     */
    containerId?: number;
    volumeDivider?: number;
    pourTime?: number;
    promptForSerial?: boolean;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
    externalKeys?: ExternalKeys;
    externalKey?: ExternalKey;
    status?: FactorDetailsView.StatusEnum;
    container?: FactorDetailsViewContainer;
    barcodes?: Array<FactorDetailsViewBarcodes>;
    factorNotes?: Array<FactorDetailsViewFactorNotes>;
    stock?: FactorDetailsViewStock;
}
export namespace FactorDetailsView {
    export type StatusEnum = 'active' | 'disabled';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Disabled: 'disabled' as StatusEnum
    };
}